import { render, staticRenderFns } from "./TeachersTable.vue?vue&type=template&id=da94bed4&scoped=true"
import script from "./TeachersTable.vue?vue&type=script&lang=ts"
export * from "./TeachersTable.vue?vue&type=script&lang=ts"
import style0 from "./TeachersTable.vue?vue&type=style&index=0&id=da94bed4&prod&lang=scss&scoped=true"
import style1 from "./TeachersTable.vue?vue&type=style&index=1&id=da94bed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da94bed4",
  null
  
)

export default component.exports